require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-womeninalternativeinvestments.json") })
        }
      }, "path---insights-womeninalternativeinvestments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-womeninalternativeinvestments!./.cache/json/insights-womeninalternativeinvestments.json
// module id = 1135
// module chunks = 231608221292675